var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("v-app", { attrs: { id: "inspire" } }, [
        _c(
          "div",
          [
            _c(
              "v-app-bar",
              {
                attrs: {
                  color: "deep-purple accent-4",
                  dense: "",
                  dark: "",
                  fixed: ""
                }
              },
              [
                _c("v-app-bar-nav-icon"),
                _c("v-toolbar-title", [_vm._v("Page title")]),
                _c("v-spacer"),
                _c(
                  "v-btn",
                  { attrs: { icon: "" } },
                  [_c("v-icon", [_vm._v("mdi-heart")])],
                  1
                ),
                _c(
                  "v-btn",
                  { attrs: { icon: "" } },
                  [_c("v-icon", [_vm._v("mdi-magnify")])],
                  1
                ),
                _c(
                  "v-menu",
                  {
                    attrs: { left: "", bottom: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  { attrs: { icon: "" } },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [_c("v-icon", [_vm._v("mdi-dots-vertical")])],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "v-list",
                      _vm._l(5, function(n) {
                        return _c(
                          "v-list-item",
                          { key: n, on: { click: function() {} } },
                          [
                            _c("v-list-item-title", [
                              _vm._v("Option " + _vm._s(n))
                            ])
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-list",
              { attrs: { "two-line": "" } },
              [
                _c(
                  "v-list-item-group",
                  {
                    attrs: { "active-class": "pink--text" },
                    model: {
                      value: _vm.selected,
                      callback: function($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected"
                    }
                  },
                  [
                    _vm._l(_vm.items, function(item, index) {
                      return [
                        _c("v-list-item", {
                          key: item.title,
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  return [
                                    _c(
                                      "v-list-item-action",
                                      [_c("v-checkbox")],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", {
                                          domProps: {
                                            textContent: _vm._s(item.title)
                                          }
                                        }),
                                        _c("v-list-item-subtitle", {
                                          staticClass: "text--primary",
                                          domProps: {
                                            textContent: _vm._s(item.headline)
                                          }
                                        }),
                                        _c("v-list-item-subtitle", {
                                          domProps: {
                                            textContent: _vm._s(item.subtitle)
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-action",
                                      [
                                        _c("v-list-item-action-text", {
                                          domProps: {
                                            textContent: _vm._s(item.action)
                                          }
                                        }),
                                        _c(
                                          "v-btn",
                                          { attrs: { icon: "" } },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "grey lighten-1"
                                                }
                                              },
                                              [_vm._v("mdi-dots-vertical")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        index < _vm.items.length - 1
                          ? _c("v-divider", { key: index })
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }